// extracted by mini-css-extract-plugin
module.exports = {"ExercisesContent":"ExercisesContent-module__ExercisesContent___3A2PU","ExercisesContentSwitcher":"ExercisesContent-module__ExercisesContentSwitcher___1h49T"};